<div class="login_mainwrapper force-password-change">
  <div class="login_subwrapper">
    <div class="logo-mainwrapper">
      <div class="logo-subwrapper">
        <img
          src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
          alt="DNA Logo"
        />
      </div>
    </div>

    <h2>Change Password</h2>

    <form
      class="login-form"
      autocomplete="off"
      [formGroup]="loginForm"
      (ngSubmit)="onSubmit()"
    >
      <!-- New Password -->
      <div class="inputwrapper">
        <div class="iconwrapper"><i class="fa fa-key" aria-hidden="true"></i></div>

        <mat-form-field appearance="outline" class="login-full-width">
          <input
            matInput
            [type]="hide ? 'password' : 'text'"
            formControlName="password"
            placeholder="New Password"
            autocomplete="off"
            required
          />
          <button
            mat-icon-button
            matSuffix
            (click)="hide = !hide; $event.preventDefault()"
            [attr.aria-label]="'Toggle password visibility'"
            [attr.aria-pressed]="hide"
            type="button"
          >
            <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>

        <ng-container
          *ngIf="
            loginForm.get('password')?.invalid &&
            (loginForm.get('password')?.dirty || loginForm.get('password')?.touched)
          "
        >
          <span class="error">{{ errors?.password }}</span>
        </ng-container>
      </div>

      <!-- Confirm Password -->
      <div class="inputwrapper">
        <div class="iconwrapper"><i class="fa fa-key" aria-hidden="true"></i></div>

        <mat-form-field appearance="outline" class="login-full-width">
          <input
            matInput
            [type]="chide ? 'password' : 'text'"
            formControlName="cpassword"
            placeholder="Confirm Password"
            autocomplete="off"
            required
          />
          <button
            mat-icon-button
            matSuffix
            (click)="chide = !chide; $event.preventDefault()"
            [attr.aria-label]="'Toggle confirm password visibility'"
            [attr.aria-pressed]="chide"
            type="button"
          >
            <mat-icon>{{ chide ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>

        <ng-container
          *ngIf="
            loginForm.get('cpassword')?.invalid &&
            (loginForm.get('cpassword')?.dirty || loginForm.get('cpassword')?.touched)
          "
        >
          <span class="error">{{ errors?.cpassword }}</span>
        </ng-container>
      </div>

      <h5 class="force_hint">
        * We recommend changing your password on first login to ensure your account's security and ease of access in the future.
      </h5>

      <button
        mat-raised-button
        class="submit"
        type="submit"
        [disabled]="loader"
        [ngClass]="loader ? 'disabled' : ''"
      >
        Change Password
      </button>

      <mat-progress-bar *ngIf="loader" mode="indeterminate"></mat-progress-bar>
    </form>
  </div>
</div>
